import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '@/lib/api-client';
import type { PaymentRow } from '../types';

export function invoicePaymentsKey(invoiceId: string | undefined) {
  return ['invoice-payments', invoiceId] as const;
}

export function useInvoicePayments(invoiceId: string | undefined, enabled = true) {
  return useQuery<PaymentRow[]>({
    queryKey: invoicePaymentsKey(invoiceId),
    enabled: enabled && invoiceId !== undefined && invoiceId.length > 0,
    queryFn: () =>
      apiRequest<PaymentRow[]>(`/invoices/${encodeURIComponent(invoiceId ?? '')}/payments`),
  });
}
